export const StatsSummary = ({ botStatus, dailyStats, currentMartingale, currentAmount }) => {
    return (
        <div className="bg-slate-800 p-3 rounded-lg border border-slate-700">
            <h2 className="text-sm font-semibold text-white mb-2">
                Quick Stats
            </h2>

            <div className="space-y-1">
                {/* Bot Status */}
                <div className="flex items-center justify-between py-1 border-b border-slate-700">
                    <div className="flex items-center gap-1.5">
                        <span className="text-sm">🤖</span>
                        <span className="text-xs text-slate-400">Status</span>
                    </div>
                    <span className={`text-xs font-semibold ${
                        botStatus.toLowerCase().includes('running') 
                            ? 'text-green-400' 
                            : 'text-red-400'
                    }`}>
                        {botStatus}
                    </span>
                </div>

                {/* Current Amount */}
                <div className="flex items-center justify-between py-1 border-b border-slate-700">
                    <div className="flex items-center gap-1.5">
                        <span className="text-sm">💵</span>
                        <span className="text-xs text-slate-400">Current Amount</span>
                    </div>
                    <span className="text-xs font-semibold text-blue-400">
                        ${currentAmount !== null ? currentAmount : '--'}
                    </span>
                </div>

                {/* Daily Target */}
                <div className="flex items-center justify-between py-1 border-b border-slate-700">
                    <div className="flex items-center gap-1.5">
                        <span className="text-sm">🎯</span>
                        <span className="text-xs text-slate-400">Daily Target</span>
                    </div>
                    <div className="flex items-center gap-2">
                        <span className="text-xs font-semibold text-purple-400">
                            ${dailyStats.target !== null ? dailyStats.target : '--'}
                        </span>
                        {dailyStats.targetReached && (
                            <span className="text-xs">✅</span>
                        )}
                    </div>
                </div>

                {/* Today's Profit */}
                <div className="flex items-center justify-between py-1 border-b border-slate-700">
                    <div className="flex items-center gap-1.5">
                        <span className="text-sm">💰</span>
                        <span className="text-xs text-slate-400">Today's Profit</span>
                    </div>
                    <span className="text-xs font-semibold text-green-400">
                        ${dailyStats.profit !== null ? dailyStats.profit.toFixed(2) : '--'}
                    </span>
                </div>

                {/* Remaining */}
                <div className="flex items-center justify-between py-1 border-b border-slate-700">
                    <div className="flex items-center gap-1.5">
                        <span className="text-sm">📊</span>
                        <span className="text-xs text-slate-400">Remaining</span>
                    </div>
                    <span className="text-xs font-semibold text-amber-400">
                        ${dailyStats.remaining !== null ? dailyStats.remaining : '--'}
                    </span>
                </div>

                {/* Martingale */}
                <div className="flex items-center justify-between py-1">
                    <div className="flex items-center gap-1.5">
                        <span className="text-sm">🔄</span>
                        <span className="text-xs text-slate-400">Martingale</span>
                    </div>
                    <span className="text-xs font-semibold text-pink-400">
                        {currentMartingale !== null ? currentMartingale : '--'}
                    </span>
                </div>
            </div>
        </div>
    );
};
